<div class="w-12"
     style="min-height:2em;">
    @if (content) {
    <!-- Title -->
    <div class="flex flex-middle">
        <span class="h2 p-r-2"
              *iCms="'title' of content"></span>
        <div class="inline-block">
            <span class="circle-wrapper fs-8 bg-col-23">
                <i class="icon-gift"
                   [style.padding-top]="'0.1rem'"
                   [style.font-size]="'25px'"></i>
            </span>
        </div>
    </div>
    <!-- Image/video -->
    @if (content?.image ||content.video) {
    <div class="ratio-1-1 m-t-3 m-b-3 w-12">
        @if (content?.image && !content?.video) {
        <img [dfImage]="content?.image"
             ratio="1/1"
             fill>
        } @else {
        <local-vimeo-player class="rf"
                            [video-id]="content.video"
                            [autoplay-in-viewport]="true"
                            [background]="true" />
        }
    </div>
    }
    <!-- Upsell points -->
    @for (line of content.upsell_points; track $index) {
    <div class="p-t-2 flex flex-middle">
        <div class="circle-wrapper bg-col-23 fs-8 m-r-2">
            <span class="c1">{{$index + 1}}</span>
        </div>
        <span *iCms="'text' of line"></span>
    </div>
    }
    <!-- Bottom text -->
    <div class="p-t-5"
         *iCms="'bottom_text' of content"></div>
    }
</div>
